<template>
  <v-calendar
    ref="calendar"
    :weekdays="[0, 1, 2, 3, 4, 5, 6]"
    :type="calendarType"
    v-model="focus"
    :now="today"
    color="accent"
    :events="events"
    :locale="locale"
    :event-color="getEventColor"
    @click:event="showEvent"
    @click:more="viewDay"
    @click:date="viewDay"
    @change="fetchEvents"
  >
    <template #event="{ event }">
      <div>
        <strong>{{ event.machinename }}</strong>
        {{ event.planname }}
      </div>
    </template>
  </v-calendar>
</template>

<script>
import {
  mapState,
  mapMutations,
  mapActions,
  mapGetters,
} from 'vuex';

export default {
  name: 'TaskCalendar',
  data() {
    return {
      events: [],
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
    };
  },
  mounted() {
    this.setCalendarRef(this.$refs.calendar);
  },
  computed: {
    ...mapGetters('maintenanceTask', ['taskStatus', 'task']),
    ...mapGetters('helper', ['locale']),
    ...mapState('maintenanceTask', [
      'today',
      'view',
      'calendarFocus',
      'calendarRef',
    ]),
    calendarType: {
      get() {
        return this.view;
      },
      set(val) {
        this.setView(val);
      },
    },
    focus: {
      get() {
        return this.calendarFocus;
      },
      set(val) {
        this.setCalendarFocus(val);
      },
    },
  },
  methods: {
    ...mapActions('maintenanceTask', ['fetchTaskList']),
    ...mapMutations('maintenanceTask', [
      'setCalendarFocus',
      'setCalendarRef',
      'setView',
    ]),
    ...mapMutations('webApp', ['setFilter']),
    getTaskColor(status) {
      return this.taskStatus(status).color;
    },
    getEventColor(event) {
      return event.color;
    },
    viewDay({ date }) {
      this.setCalendarFocus(date);
      this.setView('day');
    },
    formatDate(timestamp) {
      const a = new Date(timestamp);
      return `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`;
    },
    async fetchEvents({ start, end }) {
      const min = start.date;
      const max = end.date;
      this.setFilter({
        field: 'date',
        value: {
          value: [min, max],
          operation: 'range',
        },
      });
      await this.fetchTaskList();
      this.start = start;
      this.end = end;
      this.setEvents(this.task);
    },
    setEvents(tasks) {
      if (tasks) {
        const events = tasks.map((task) => {
          let s = 0;
          let e = 0;
          const name = task.id;
          const color = this.getTaskColor(task.status);
          if (task.status === 'new' || task.status === 'assigned') {
            s = this.formatDate(task.planstarttime);
            e = this.formatDate(task.planendtime);
          } else if (task.status === 'in progress') {
            s = this.formatDate(task.acturalstarttime);
            e = this.formatDate(task.planendtime);
          } else if (task.status === 'complete') {
            s = this.formatDate(task.acturalstarttime);
            e = this.formatDate(task.acturalendtime);
          }
          return {
            ...task,
            name,
            color,
            start: s,
            end: e,
          };
        });
        this.events = events;
      }
    },
    showEvent({ event }) {
      this.$router.push({
        name: 'maintenanceTaskDetails',
        params: { id: event.id },
      });
    },
  },
  watch: {
    task: {
      deep: true,
      handler(tasks) {
        this.setEvents(tasks || []);
      },
    },
  },
};
</script>
